import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '../../../../components/tailwind';
import { FiChevronRight } from 'react-icons/fi';
import classNames from 'classnames';
import { Views } from '..';
import { formatCurrency } from '@utils/formatters.util';

type Props = {
  onUpdateClick: () => void;
  view: Views;
  quantity: number;
};

const ActiveVariant = ({ onUpdateClick, view, quantity }: Props) => {
  const { details } = useSelector((state: any) => state.pdpItem);

  const onClick = (e) => {
    if (view === Views.DESIGN) {
      e.preventDefault();
      onUpdateClick();
      return;
    }
  };

  const [typeLabel, ...attributeValues] = details.displayValues || [];
  const displayName = typeLabel || details.displayName;

  return (
    <div
      className={classNames('tw-flex tw-items-center tw-justify-between tw-gap-2 tw-overflow-hidden', {
        'tw-my-5 tw-cursor-pointer tw-rounded-xl tw-border-x tw-border-y tw-border-neutrals-light-grey tw-p-4 [&_*]:tw-cursor-pointer hover:tw-bg-neutral-100 tw-transition tw-duration-200':
          view === Views.DESIGN,
        'tw-my-4 tw-border-b tw-border-neutrals-light-grey tw-pb-4': [
          Views.REVIEW,
          Views.REVIEW_UPDATE_PREVIEW,
        ].includes(view),
      })}
      onClick={onClick}>
      <div
        className={classNames('tw-mb-0 tw-w-full tw-text-xs tw-font-bold tw-text-brand-black', {
          'tw-whitespace-nowrap': view === Views.DESIGN,
        })}>
        {displayName}
        {attributeValues?.length > 0 && <div className='tw-text-xs tw-font-normal tw-text-muted'>
          {attributeValues.join(' | ')}
        </div>}
      </div>

      <div
        className={classNames('tw-flex tw-justify-end', {
          'tw-w-full': view === Views.DESIGN,
        })}>
        {[Views.REVIEW, Views.REVIEW_UPDATE_PREVIEW].includes(view) ? (
          <p className='tw-mb-0 tw-text-right tw-text-xs tw-font-bold tw-text-brand-black'>
            {formatCurrency(details?.rate * (quantity || 1))}
          </p>
        ) : (
          <Button type='button' variant='link' size='md' noPadding className='tw-pointer-events-none'>
            <div className='tw-inline-flex tw-items-center'>
              <span>Update</span>
              <FiChevronRight size={24} className='t-text-brand-black' />
            </div>
          </Button>
        )}
      </div>
    </div>
  );
};

export default memo(ActiveVariant);
